import { MetaSegment, WorldLocation, SearchResultStatus } from "@skv/core";

export interface OrganisationSearchResult {
  category: MetaSegment<number>;
  location: WorldLocation;
  id: number;
  name: string;
  friendlyName: string;
  url: string;
  agencyName: string;
}

export interface OrganisationSearchResults {
  totalCount: number;
  organisations: OrganisationSearchResult[];
  page: number;
  pageSize: number;
  totalPages: number;
  canonicalUrl: string;
}

export interface State {
  loading: boolean;
  error: Error | null | false;
  data: { [searchQuery: string]: OrganisationSearchResults };
  status: SearchResultStatus;
}

export type ActionTypes =
  | {
      type: "ORG_RESULT:FETCH:START";
    }
  | {
      type: "ORG_RESULT:FETCH:END";
      payload: {
        searchQuery: string;
        data: OrganisationSearchResults;
      };
    }
  | {
      type: "ORG_RESTULT:FETCH:ERROR";
      payload: {
        error: Error;
      };
    };

export const reducer = (
  state: State = {
    loading: false,
    error: false,
    data: {},
    status: SearchResultStatus.IDLE,
  },
  action: ActionTypes
): State => {
  switch (action.type) {
    case "ORG_RESULT:FETCH:START":
      return {
        ...state,
        loading: true,
        status: SearchResultStatus.FETCHING_DATA,
      };
    case "ORG_RESULT:FETCH:END":
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          [action.payload.searchQuery]: action.payload.data,
        },
        status: SearchResultStatus.IDLE,
      };
    case "ORG_RESTULT:FETCH:ERROR":
      return {
        ...state,
        error: action.payload.error,
        status: SearchResultStatus.FETCH_ERROR,
      };
    default:
      return state;
  }
};
